// extracted by mini-css-extract-plugin
export var bleed = "Section-module--bleed--75579";
export var blueBackground = "Section-module--blue-background--d0d73";
export var breakoutImage = "Section-module--breakout-image--5103b";
export var clamp = "Section-module--clamp--756e1";
export var darkGreyBackground = "Section-module--dark-grey-background--90a15";
export var darkerGreyBackground = "Section-module--darker-grey-background--05320";
export var greyBackground = "Section-module--grey-background--7a2b6";
export var layout = "Section-module--layout--a8bbe";
export var lgGap = "Section-module--lg-gap--46d60";
export var lgPadding = "Section-module--lg-padding--13792";
export var lightBlueBackground = "Section-module--light-blue-background--3e1e7";
export var mdGap = "Section-module--md-gap--95283";
export var mdPadding = "Section-module--md-padding--52c6e";
export var noGap = "Section-module--no-gap--266fe";
export var noPadding = "Section-module--no-padding--ebe8c";
export var pull = "Section-module--pull--5a52f";
export var section = "Section-module--section--085e9";
export var xlGap = "Section-module--xl-gap--a316c";
export var xlPadding = "Section-module--xl-padding--67c83";
export var xlSpacebelow = "Section-module--xl--spacebelow--ad743";